/**
 * A rate that can actually be converted with: present, numeric, finite and positive.
 * Everything else — a missing field, a string, NaN, Infinity, zero, a negative — is "no
 * rate" rather than an error, and the caller falls back to canonical amounts.
 */
export function isUsableRate(rate: unknown): rate is number {
    return typeof rate === 'number' && Number.isFinite(rate) && rate > 0
}

/**
 * Convert a canonical amount at a rate expressed as display units per one canonical unit.
 *
 * Returns the **exact product** — no rounding. Minor-unit precision is a
 * property of rendering, chosen by the surface that renders it, so that a converted and an
 * unconverted amount obey the same rule and rounding policy can change without touching
 * conversion. Rounding here would round twice, since psearch converts its own prices.
 *
 * `undefined` rate means no conversion applies — the display currency is already the
 * canonical one, or no usable rate was available. Both pass the amount
 * through unchanged, which is what keeps canonical-currency output byte-identical.
 */
export function convertAmount(amount: number, rate: number | undefined): number {
    return rate === undefined ? amount : amount * rate
}
